// src/utils/firebaseCompat.js

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';

const firebaseConfig = { //live server
            //apiKey: "AIzaSyCvpJxEC5Li4Il49syhcgitvs7FngaIaW4", //test 
            //apiKey: "AIzaSyB09CxpGugLnlAXX8LceFyj8D6RZSDb0VA", //live unrestricted
            apiKey: "AIzaSyAw-jO5bEzGEOInFnvkNLYgTxgIJzLaNk8",//live restricted
            authDomain: "leadershipplatform-158316.firebaseapp.com",
            databaseURL: "https://leadershipplatform-158316.firebaseio.com",
            projectId: "leadershipplatform-158316",
            storageBucket: "leadershipplatform-158316.appspot.com",
            messagingSenderId: "438289288307",
            appId: "1:438289288307:web:5a8fafc9aeb1164e6cee06",
            measurementId: "G-R7QQ8R025S"
       };

// const firebaseConfig = { //test server
//   apiKey: "AIzaSyAUC1HV-b0ckQc5shndzy0o3VhjnzPTlMg", //live restricted
//   authDomain: "thinklead-b3299.firebaseapp.com",
//   databaseURL: "https://thinklead-b3299.firebaseio.com",
//   projectId: "thinklead-b3299",
//   storageBucket: "thinklead-b3299.appspot.com",
//   messagingSenderId: "595347650471",
//   appId: "1:595347650471:web:cc58d3aa6451237f0f2882",
//   measurementId: "G-R7QQ8R025S"
// };

// This creates a SECOND Firebase app in compat mode (safe, does not touch your main v9 app)
firebase.initializeApp(firebaseConfig, 'signup-compat');

export default firebase; // ← this gives you firebase.auth(), firebase.database() exactly like old times
////////////////////////////////////////////////////////////////////////////////
// // src/utils/firebaseCompat.js
// import { initializeApp } from 'firebase/compat/app';
// import 'firebase/compat/auth';
// import 'firebase/compat/database';

// const firebaseConfig = {
//         apiKey: "AIzaSyAcAjiyCIE1T0QOl-xF37nnFK11Jd8cq2w",
//         authDomain: "leadershipplatform-158316.firebaseapp.com",
//         databaseURL: "https://leadershipplatform-158316.firebaseio.com",
//         projectId: "leadershipplatform-158316",
//         storageBucket: "leadershipplatform-158316.appspot.com",
//         messagingSenderId: "438289288307",
//         appId: "1:438289288307:web:5a8fafc9aeb1164e6cee06"
// };

// // This creates a SECOND Firebase app in compat mode (does NOT interfere with your main v9 app)
// const compatApp = initializeApp(firebaseConfig, 'compat');
// const firebaseCompat = {
//   auth: () => compatApp.auth(),
//   database: () => compatApp.database(),
// };

// export default firebaseCompat;